export const LOCAL = 'local'
